import React from "react"
import react_img from '../assets/react_img.png'


function CoreConcept(props)
{
  return (
    <ul id='core-concepts'>
      <li key={props.id}>
      <img className='img' src ={props.image} alt={props.title}/>
      <h3>
        {props.title} 
      </h3>
      <p>
        {props.description}
      </p>
      </li>
    </ul>

  )
}

function ReturnHome()
{
  return(
    <section>
      <h1>Welcome!</h1>
      <h2>Please Ship or Drive</h2>
   
      <h1>____</h1>
      <main>

<section id="contact">
  <h2>Contact</h2>
  <ul>
    {/* {CORE_CONCEPTS.map(item => <CoreConcept key={item.title} {...item}/>)}  */}
    <CoreConcept 
    title="BigTrek Team" 
    description="ander@big-trek.com"
    image={react_img}
    />
  </ul>
</section>

</main>
    </section>
  )
}

export default function HomePage()
{
  return(
    <div id='main-bg'>

  
      <ReturnHome/>


   
    </div>
  )
}